// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5443) return "static/chunks/ad7f724d-e5ac97111131e672.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"35cf7363a42d1c38","6350":"f241fd1bb7aff761","7856":"df677361132301ad"}[chunkId] + ".js";
};